/* istanbul ignore file */
import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "../utils/baseQuery";
import { showNotifier, setGlobalLoader } from "../../store/globalSlice";
import store from "../../store";
import { setTotalDetails } from "../../store/totalSlice";
import config from "../../config";

// Get access token directly from redux store.
const getAuthHeaders = () => ({
  Authorization: `Bearer ${store.getState()?.global?.authState?.id_token}`,
});

export const totalApi = createApi({
  reducerPath: "total/api",
  tagTypes: ["Total"],
  baseQuery: baseQuery({ baseUrl: config.PogBaseUrl }),
  endpoints: (builder) => ({
    getTotal: builder.query({
      providesTags: ["Total"],
      query: ({ storeId }) => ({
        url: config.GetTotal,
        method: "post",
        headers: getAuthHeaders(),
        data: {
          StoreId: storeId,
        },
      }),
      async onQueryStarted(_details, { dispatch, queryFulfilled }) {
        try {
          if (_details?.type === "initialLoad") {
            dispatch(setGlobalLoader(true));
          }
          const { data } = await queryFulfilled;
          dispatch(setGlobalLoader(false));
          dispatch(setTotalDetails(data));
        } catch {
          dispatch(setGlobalLoader(false));
          dispatch(
            showNotifier({
              message: "Something went wrong. Please try again.",
              severity: "error",
            })
          );
        }
      },
    }),
  }),
});

export const { useLazyGetTotalQuery } = totalApi;
